<template>
   <div class="container">
      <div class="video-warp">
        <VideoPlayer
          :id="'iantest' + type"
          ref="videlPlayerRef"
          type="application/x-mpegURL"
          v-if="m3u8"
          :src="m3u8"
          :controls="false"
          autoplay
          @volume-change="volumechange"
          @muted-change="mutedchange"
          @ended="ended"
        />
      </div>
      <div>
        <legend style="font-size: 20px; font-weight: bold; margin-left:20px">功能, 經由 {{ AccessType }} 連線</legend>
        <div v-if="isPlayback" class="rowDiv contentCenter mt-1">
            <v-text-field label="開始時間 (時間格式:2024-01-01 23:59:59)" dense hide-details outlined filled v-model="starttime" color="black" class="mb-2" style="width:350px"></v-text-field>
            <v-text-field label="結束時間 (時間格式:2024-01-01 23:59:59)" dense hide-details outlined filled v-model="endtime"   color="black" class="mb-2" style="width:350px"></v-text-field>
        </div>
        <div v-if="isLive" class="rowDiv contentCenter mt-1">
            <v-text-field label="頻道" dense hide-details outlined filled v-model="channel" color="black" class="mb-2" style="width:350px"></v-text-field>
        </div>
      </div>
      <div v-if="isPlayback">
        <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="startPlayback">開始回放</v-btn>
        <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="stopPlayback">停止回放</v-btn>
        <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="pausePlayback">暫停</v-btn>
        <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="resetSpeed">恢復</v-btn>
        <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="slowDown">慢放</v-btn>
        <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="fastForward">快放</v-btn>
        <v-btn depressed color="success" class="btn_fontSize ml-2 my-2">下載</v-btn>
      </div>
      <div v-if="isLive">
        <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="startLive">開始串流</v-btn>
        <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="stopLive">停止串流</v-btn>
      </div>
    </div>
</template>

<script>
import VideoPlayer from '../components/VideoPlayer.vue'
export default {
  components: {
    VideoPlayer
  },
  data() {
    return {
      AccessType: null,
      storeParam: null,
      type: null,
      starttime: null,
      endtime: null,
      token: null,
      m3u8: null,
      channel: null,
      speed: 1,
    };
  },
  computed: {
    isLive() {
      return this.type === 1
    },
    isPlayback() {
      return this.type === 0
    }
  },
  watch: {
    speed() {
      this.$refs.videlPlayerRef.setPlaybackRate(this.speed)
    }
  },
  created() {
    this.$emit('setAppbar', { isHide: true })
  },
  async mounted() {
    this.AccessType = this.$store.getters.getAccessType
    this.storeParam = this.$store.getters.getRouteParam
    this.$store.commit('setRouteParam', []);
    this.$store.commit('setAccessType', null);

    const [host, username, password, port, type, channel, start, end] = this.storeParam
    this.host = host
    this.port = port
    this.username = username
    this.password = password
    this.starttime = start?.replace('T', ' ')
    this.endtime = end?.replace('T', ' ')
    this.type = type
    this.channel = channel

    // Fake data
    this.host = '172.16.40.134'
    this.port = 8585
    this.username = 'shinadmin'
    this.password = 'Shin@12664093'

    if (!this.AccessType && this.storeParam.length === 0) {
      this.$router.push('/Site_Info')
      return
    }
  },
  methods: {
    async startPlayback() {
      if (this.m3u8) {
        return this.$refs.videlPlayerRef.play()
      }

      const auth = btoa(`${this.username}:${this.password}`)
      const base = `http://${this.host}`

      const token = await fetch(`${base}:${this.port}/Config/Login`, {
        headers: {
          Authorization: `Basic ${auth}`
        }
      })
        .then(response => response.json())
        .then(([data]) => data.Token)

      await fetch(`${base}:${this.port}/Config/GetPlaybackList`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          Cam: "0",
          FileType: "2",
          RecType: "0",
          Index: "0",
          StartTime: this.starttime.replace('T', ' '),
          EndTime: this.endtime.replace('T', ' ')
        })
      })
        .then(response => response.text())
        .then((text) => {
          if (text === 'failed') {
            throw text
          }

          return JSON.parse(text)
        })
        .then((data) => {
          if (data.err) {
            throw data.err
          }

          const url = data[data.length - 1]?.Url
          this.m3u8 = `${base}${url}`
        })
        .catch(err => alert(err))

      this.token = token
    },

    stopPlayback() {
      this.m3u8 = null
    },

    pausePlayback() {
      this.$refs.videlPlayerRef.pause()
    },

    fastForward() {
      this.speed *= 2
    },

    slowDown() {
      this.speed /= 2
    },

    resetSpeed() {
      this.speed = 1
    },


    async startLive() {
      this.m3u8 = `http://${this.host}/hls/${this.channel}-1/index.m3u8`
    },

    stopLive() {
      this.m3u8 = null
    },

    volumechange() { console.log('volumechange'); },
    mutedchange() { console.log('mutedchange'); },
    ended () { console.log('ended'); },
  }
};
</script>

<style scoped>

.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.video-warp {
  width: 800px;
  aspect-ratio: 16 / 9;
  background: #4C4B4B;
  border: 1px solid rgb(255, 204, 0);
}
</style>
